export const PAGE_NAME = 'guide_intro';

export const INTRO_STEP_INFO = [
  {
    title: '什么是网心云？',
    text: `<p>从大数据中了解到，大部分家庭的宽带会存在以下情况：</p>
    <p>24小时运转，却只在下班回家到睡觉前这段时间内使用。一天里至少有19个小时，宽带都是闲置的。</p>
    <p>每年宽带费少则几百，多则几千，但实际使用时长仅20%。</p>
    <p><em>换算成钱的话，等同于80%的宽带费都被浪费了!</em><br />假如能把这80%的资源利用起来呢?</p>`,
  },
  {
    title: '如何赚钱？',
    text: `<p>为了充分利用闲置网络资源，网心云推出“闲置资源共享计划” ：</p>
    <p><em>将每个家庭中的闲置带宽收集起来，供给视频厂商循环利用，同时网心云会给予用户现金奖励</em>，真正实现共享经济。</p>
    <p>要想加入共享计划也很简单，根据您的网络资源选择适合的产品，绑定到您的网心云账号上，保持稳定在线，即可赚取现金奖励!</p>`,
  },
  {
    title: '如何选择网心云产品？',
    text: `<p><em>首先，你可以根据自己现有的设备进行选择 ：</em></p>
    <p>如果你有<em>闲置的安卓手机、电脑、NAS等设备</em>可以直接安装相应的软件，保持运行在线即可!</p>
    <p>如果你没有合适的设备，并且对网心云官方推出的硬件感兴趣，想要赚更多，也可以购买硬件。连接网络、硬盘，接入电源保持在线，即可赚钱!</p>`,
  },
  {
    title: '如何选择网心云产品？',
    text: `<p><em>第二，你还可以根据自己的网络条件进行产品选择。</em>只要有网就能加入!上行网络条件越好，赚得越多!</p>
    <p>如果上行带宽在10-30M，推荐你选择手机宝、电脑宝、赚钱宝3代、纳思小星等。</p>
    <p>如果上行带宽在50-100M，推荐选择OEC系列。</p>
    <p>如果上行带宽在150-300M，推荐选择OES系列。</p>
    <p>如果上行带宽在300M以上，推荐选择x86专业版。</p>`,
    tips: 'tips: 如果不清楚自己的上行带宽有多少，可以去app网络测速进行检测!',
  },
  {
    title: '新人上机有大奖!',
    text: `<p>怎么样，准备好了吗? 现在加入共享计划，就能开始赚钱!</p>
    <p><em>更有丰厚的新人奖励，绑定任意设备即有现金奖励到账!更有加成卡助你赚更多!</em></p>`,
  },
];
